import { Checkbox } from 'components/ui/checkbox';
import { IFilterConfig, IFilterConfigList } from 'components/filter/types';
import React, { useEffect } from 'react';
import { isListItemPresent } from 'utils/filter';

interface IProps {
  item: IFilterConfig;
  setValues: (arg1: string, arg2: string[]) => void;
  setSelected: (arg1: string, arg2: boolean) => void;
}

// DOM ids can't contain whitespace and option names ("ACH Authorized") do;
// slug them so the <label htmlFor> association works, namespaced by filter key
// to stay unique across sections.
const toId = (...parts: string[]) =>
  parts.join('-').toLowerCase().replace(/\s+/g, '-');

const ListExport = ({ item, setValues, setSelected }: IProps): JSX.Element => {
  const { key, label, data } = item;
  const { values, options } = data as IFilterConfigList;

  useEffect(() => {
    setSelected(key, values.length > 0);
  }, [values]);

  return (
    <>
      <div className="text-sm font-medium leading-6 text-gray-blue-80">
        {label}
      </div>
      <div
        className={`${
          options.length > 3 ? 'columns-2' : 'columns-1'
        } pb-5 pr-4 pt-2`}
      >
        {options.map((option) => {
          const optionId = toId(key, option.name);
          return (
            <div className="mb-1 flex items-center gap-2.5" key={option.name}>
              <Checkbox
                id={optionId}
                data-testid={option.name}
                checked={isListItemPresent(values, option.value)}
                onCheckedChange={(checked) => {
                  if (checked === true) {
                    setValues(key, values.concat(option.value));
                  } else {
                    const arr = values.filter((v) =>
                      Array.isArray(option.value)
                        ? !option.value.includes(v)
                        : v !== option.value
                    );
                    setValues(key, arr);
                  }
                }}
              />
              <label
                htmlFor={optionId}
                className="body-subtext cursor-pointer text-gray-blue-80"
              >
                {option.name || (option as unknown as string)}
              </label>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ListExport;
